<template>
  <section>
    <div id="footer" class="w-full flex sm:block bg-black">
      <div class="w-2/12 pl-8 sm:w-full bg-black p-4">
        <img :src="require('../assets/footer/footer-logo.png')" alt="" />
      </div>

      <div class="w-3/12 sm:w-full">
        <div class="py-4 pr-20 pl-8 sm:px-6 sm:py-0">
          <div class="phone">Phone</div>
          <div class="phone-content">604-498-6388</div>
        </div>

        <div class="py-4 pr-20 pl-8 sm:px-6 sm:py-0">
          <div class="phone">Address</div>
          <div class="phone-content">
            13591 King George Blvd. Surrey, B.C. V3T 2V1
          </div>
        </div>
      </div>

      <div class="w-3/12 sm:w-full">
        <div class="py-4 pr-20 pl-8 sm:px-6 sm:py-0">
          <div class="phone">Email</div>
          <div class="phone-content">sushishogunsurrey@gmail.com</div>
        </div>

        <div class="py-4 pr-20 pl-8 sm:px-6 sm:py-0">
          <div class="phone">Business Hours</div>
          <div class="phone-content">Mon - Sun： 11am - 11:30pm</div>
        </div>
      </div>
      <div class="w-3/12 sm:w-full pt-4 pl-8 sm:px-6 sm:pt-14">
        <img
          :src="require('../assets/footer/footer-logo-text.png')"
          alt=""
          class="mb-4 w-8/12 sm:w-6/12"
        />

        <p class="footer-text w-4/5 sm:w-full">
          With great originality and fine tuning on Japanese Cuisine, we want to
          create and lead the brand new category and definition for Japanese
          Fusion.
        </p>
      </div>
    </div>
    <div id="copyright" class="bg-black flex flex-row sm:flex-col py-4 px-8 sm:px-6 sm:py-0">
      <div class="w-2/3 text-sm sm:w-full sm:pt-14">
        <p>
          SUSHI SHOGUN © has all the rights and reserve of final interpretation
          and the copyright for all the contents on the website.
        </p>
      </div>
      <div class="w-1/4 pl-10 text-xl sm:order-first sm:w-full sm:text-left sm:text-xl" style="font-family: Times">
        <p>*We have a liquor licence</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style>
.phone {
  font-family: avenirLight;
  font-style: normal;
  font-weight: normal;
  font-size: 0.75rem;
  line-height: 20px;
  /* identical to box height, or 125% */

  letter-spacing: 0.02em;

  /* grey */

  color: #757577;
}
.phone-content {
  font-family: Times;
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 32px;
  /* identical to box height, or 133% */

  letter-spacing: 0.05em;
  text-transform: uppercase;

  /* white */

  color: #ffffff;
}
#footer {
  background: black;

  color: white;
  padding-top: 10rem;
  padding-bottom:8rem;
}
#copyright {
  background: black;
  color: white;

}
.footer-text {
 font-family: avenirLight;
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 24px;
  /* or 133% */


  letter-spacing: 0.05em;

  /* white */

  color: #ffffff;
}
</style>